import React from 'react';

interface Props {
  direction: 'up' | 'down';
  label: string;
}

export const UpDownTag = ({direction, label}: Props) => {
  return (
    <div className="inline-flex items-center gap-1 px-2 py-1 h-6 bg-gray-50 rounded box-border">
      <div className="w-3.5 h-3.5 flex items-center justify-center">
        {direction === 'up' ? (
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-full h-full">
            <path
              d="M2.91699 7.00008L7.00033 2.91675L11.0837 7.00008"
              stroke="#058100"
              strokeWidth="1.33333"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7 11.0834V2.91675"
              stroke="#058100"
              strokeWidth="1.33333"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ) : (
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-full h-full">
            <path
              d="M2.91699 7.00008L7.00033 11.0834L11.0837 7.00008"
              stroke="#95002D"
              strokeWidth="1.33333"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7 2.91675V11.0834"
              stroke="#95002D"
              strokeWidth="1.33333"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </div>
      <span
        className="font-medium text-xs leading-none text-gray-700"
        style={{letterSpacing: '0.0125em'}}>
        {label}
      </span>
    </div>
  );
};
